module.exports = __webpack_public_path__ + "img/TD.10f5c44c.svg";